import { render } from "./orgManage.vue?vue&type=template&id=1abdda4b&scoped=true"
import script from "./orgManage.vue?vue&type=script&lang=js"
export * from "./orgManage.vue?vue&type=script&lang=js"

import "./orgManage.vue?vue&type=style&index=0&id=1abdda4b&scoped=true&lang=scss"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abdda4b"]])

export default __exports__